import React, { useState } from "react";
import "../../../src/main.css";
import Form from "react-bootstrap/Form";
import { useEffect } from "react";
import { Button, Spinner } from 'react-bootstrap';
import CardDiv from "modules/common/card-div/CardDiv";
import moment from 'moment';
import { useConsultDoctor } from 'modules/dashboards/actionables/store';
import { toast } from "react-toastify";
import { groupSlots } from "modules/utilities/utility";

const DoctorSelection = ({
    rowData,
    interventionDocList,
    bookedLoading,
    allSlotLoading,
    setTicketObject,
    updateData,
    setUpdateData,
    docBookingData,
    ticketId
}) => {
    const { slotData, fetchDoctorSlotData } = useConsultDoctor();
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedSlot, setSelectedSlot] = useState(null);
    const [filterSlotData, setFilterSlotData] = useState([]);
    const [doctor, setDoctor] = useState(rowData?.current_assignment?.user_id);
    const [selectedDoctor, setSelectedDoctor] = useState(null);
    const [ticketSubCat, setTicketSubCat] = useState(null);
    const doctorBookingData = docBookingData.filter((engagement) => (engagement.ticket_id === ticketId))[0];

    const handleDate = (date) => {
        setSelectedDate(date);
        setSelectedSlot(null);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        fetchDoctorSlotData(rowData.case_id, doctor, ticketSubCat, toast);

    };

    const handleSlotSelection = (timeSlot) => {
        setSelectedSlot(timeSlot);
        const payload = {
            slots: timeSlot?.slots,
            slot_time: timeSlot?.slotTime,
            case_id: doctorBookingData?.case_id,
            transaction_id: doctorBookingData?.payment_id,
            consult_doctor_fees: doctorBookingData?.amount,
            isReassignedIntervention: true,
            rescheduleBookingId: doctorBookingData?._id,
        };
        setTicketObject(payload);
        setUpdateData({
            ...updateData,
            current_assignment: doctor,
            isReassignedIntervention: true,
        });

    };

    useEffect(() => {
        if (!_.isEmpty(slotData)) {
            const groupSlot = groupSlots(slotData);
            setFilterSlotData(groupSlot);
        } else {
            setFilterSlotData([]);
        }
    }, [slotData]);

    return (

        <div className="text-center">
            <Form onSubmit={handleSubmit}>
                <Form.Select
                    name="from_crm"
                    required
                    aria-label="Default select example"
                    onChange={(event) => {
                        setFilterSlotData(null);
                        setSelectedSlot(null);
                        setSelectedDate(null);
                        setSelectedDoctor(event.target.value);
                        setDoctor(event.target.value);
                    }}
                    className={`form-select ${rowData?.status === "Closed" ? "opacity-50 disabled-select" : ""}`}
                >
                    <option value="">Please Select Doctor</option>
                    {interventionDocList?.map((doctor) => (
                        <option key={doctor?.value} value={doctor?.value}>
                            {doctor?.label}
                        </option>
                    ))}
                </Form.Select>
                <Button type="submit" className="w-25 mt-4 py-2 text-center">
                    {bookedLoading ? (
                        <span className="d-flex flex-row gap-2 justify-content-center">
                            <Spinner animation="border" variant="light" />
                            <span>Submitting</span>
                        </span>
                    ) : (
                        "Submit"
                    )}
                </Button>
            </Form>

            <div className="d-flex gap-2 flex-wrap justify-content-center mt-3">
                {selectedDoctor && filterSlotData &&
                    Object.keys(filterSlotData).map((slotDate) => (
                        <div
                            key={slotDate}
                            className="cursor-pointer"
                            onClick={() => handleDate(slotDate)}
                        >
                            <CardDiv
                                title={
                                    <div className={slotDate === selectedDate ? "text-primary fw-bold" : "fw-bold"}>
                                        {moment(slotDate).format("ddd DD")}
                                    </div>
                                }
                                component={
                                    <div className={slotDate === selectedDate ? "text-primary fw-bold" : "fw-bold"}>
                                        {slotDate}
                                    </div>
                                }
                            />
                        </div>
                    ))}
            </div>

            <div className="d-flex gap-3 flex-wrap mt-5 scrollable-container" style={{ maxHeight: "50vh", overflowY: "scroll" }}>
                {selectedDate &&
                    filterSlotData[selectedDate]?.map((timeSlot) => (
                        <Button
                            key={timeSlot?.slotTime}
                            style={{ width: "100px" }}
                            onClick={() => handleSlotSelection(timeSlot)}
                            className={
                                timeSlot?.slots?.count === 0
                                    ? " py-2 fs-1 bg-secondary text-white rounded-5 cursor-na disabled pointer-events-none text-center"
                                    : selectedSlot?.slotTime == timeSlot?.slotTime
                                        ? "py-2 fs-1 bg-success text-white rounded-5 cursor-pointer text-center"
                                        : " py-2 fs-1 rounded-5  bg-white text-black border border-secondary cursor-pointer text-center"
                            }                            >
                            {moment(timeSlot?.slotTime).format("hh:mm A")}
                        </Button>
                    ))}
            </div>

        </div>

    );
};

export default DoctorSelection;